type SelectedRecordProps = {
  image: string | undefined | null;
  title: string;
};

const SelectedRecord = ({ image, title }: SelectedRecordProps) => {
  return (
    <div className="flex items-center gap-3 text-wrap">
      <img
        src={image ?? undefined}
        alt=""
        className="size-10 aspect-square object-contain"
      />
      <span className="font-[Raleway] font-medium text-sm">{title}</span>
    </div>
  );
};

export default SelectedRecord;
